import DtoReferencial from './DtoReferencial'

export default class DtoCulturesFamily extends DtoReferencial {
    constructor(object) {
        super(object)
    }
}
